export default "__VITE_ASSET__Ds4j408O__"